<template>
  <v-app dark>
    <v-toolbar color="primary" app>
      <v-toolbar-title class="headline text-uppercase">
        <span>ごしゅつい</span>
      </v-toolbar-title>
    </v-toolbar>

    <v-content>
      <Main/>
    </v-content>

    <v-footer>
      <v-flex
        secondary
        py-3
        text-xs-center
        white--text
        xs12
      >
      2019 - Created by <strong>Vertax</strong>
      </v-flex>
    </v-footer>
  </v-app>
</template>

<script>
import Main from './components/Main'

export default {
  name: 'App',
  components: {
    Main
  },
  data () {
    return {
      //
    }
  }
}
</script>
